<template>
  <div class="mt-5 mx-4 px-3">
    <!-- <h1>User Management </h1> -->
    <!-- <v-snackbar v-model="snackbar" auto-height right top :timeout="timeout" vertical> User saved. </v-snackbar> -->
    <v-card class="mx-0 elevation-0">
      <v-card-title class="mx-0 px-0 right">
        <!-- <router-link :to="{ name: 'AddArticle', path: '/articles/new'}"> -->
        <v-btn
          dark
          @click="$router.push({ name: 'AddArticle', path: '/articles/new' })"
          >Add Article
        </v-btn>
        <!-- </router-link> -->
        <!-- <v-btn color="black" class="mx-0" dark v-if="!save_article_form_display" @click="show_create_article_form">Add New Article</v-btn> -->
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search "
          single-line
          hide-details
          clearable
          v-if="this.$store.state.showSearch"
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-spacer></v-spacer>

      <!-- <v-dialog v-model="dialog" max-width="700px" max-height="700px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2 right" v-on="on">New Article</v-btn>
        </template>

        <v-card>
          <v-card-title> <span class="pl-4 pt-3 pb-0 mb-0 headline">Edit Article</span> </v-card-title>
          <v-card-text mb-0>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.title" label="Title"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.subtitle" label="Subtitle"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.version" label="Version"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.updates" label="Updates"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.group" label="Group"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <text-editor @input="editedItem.body=$event" :value="editedItem.body"></text-editor>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <v-data-table
        :headers="headers"
        :items="articles"
        hide-actions
        class="elevation-0"
        item-key="id"
        loading="true"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <tr
            :active="props.selected"
            @click="props.selected = !props.selected"
          >
            <!-- <td>
              <v-checkbox
                primary
                hide-details
                :input-value="props.selected"
              ></v-checkbox>
            </td> -->
            <td>{{ props.item.title }}</td>
            <td class="text-xs-right">{{ props.item.group }}</td>
            <td class="text-xs-right">{{ props.item.publish_date }}</td>
            <td class="text-xs-right">{{ props.item.version }}</td>
            <td class="text-xs-right">{{ props.item.at_work }}</td>
            <td class="text-xs-right">{{ props.item.updates }}</td>
            <td class="text-xs-right">{{ props.item.help }}</td>
            <td class="justify-center layout px-0">
              <!-- <v-btn @click="$router.push( name: 'EditArticle', params: { id: props.item.id, editedItem: props.item }, path: `/articles/edit/${props.item.id}`})"> -->
              <v-btn
                :to="{
                  name: 'EditArticle',
                  params: { id: props.item.id, editedItem: props.item },
                  path: `/articles/edit/${props.item.id}`,
                }"
                icon
              >
                <!-- ({ path: `/articles/edit/${item.id}`, params: { editedItem: item }}) -->
                <v-icon small class="mr-2"> edit </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import TextEditor from '@/components/artworks/TextEditor'
import axios from 'axios'
export default {
  data () {
    return {
      // editedIndex: -1,
      // editedItem: {
      //   title:'',
      //   version: '',
      //   subtitle: '',
      //   updates: '',
      //   help: '',
      //   at_work: '',
      //   support: '',
      //   show_in_route: '',
      //   group: ''
      // },
      defaultItem: {
        title: '',
        version: '',
        subtitle: '',
        updates: '',
        help: '',
        at_work: '',
        support: '',
        show_in_route: '',
        group: ''
      },
      dialog: false,
      save_article_form_display: false,
      search: '',
      selected: [],
      new_article: { title: '', versio: '' },
      headers: [
        // { text: '', align: 'center', sortable: false },
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Group', value: 'group', align: 'right' },
        { text: 'Publish Date', value: 'publish_date', align: 'right' },
        { text: 'V', value: 'version', align: 'right' },
        { text: 'AW', value: 'at_work', align: 'right' },
        { text: 'U', value: 'updates', align: 'right' },
        { text: 'H', value: 'help', align: 'right' },
        { text: '', align: 'right' }
      ],
      articles: []
    }
  },
  created: function () {
    // this.getArtists()
    this.initialize()
  },
  computed: {
    articles_d () {
      this.articles = this.$store.state.support_articles
      return this.articles
    }
  },
  methods: {
    initialize () {
      this.articles = Object.assign([], this.$store.state.support_articles)
      this.$store.dispatch('loadSupportArticles')
    },
    openArticle (item) {
      // console.log(item)
      this.$router.push({
        name: 'EditArtist',
        // path: `/articles/edit/${item.id}`,
        params: { id: item.id, editedItem: item }
      })
    },
    // saveArticle () {
    // },
    createArticle () {
      // this.snackbar = true
      let url = `${this.$globals.apiserver}/support_articles.json`
      // console.log(url)
      axios
        .post(url, this.newItem)
        .then((response) => {
          // this.result = response.data
          var o = Object.assign({ name: this.newItem.title })
          this.$store.dispatch('createArticle', o)
          this.save_user_form_display = false
          this.snackbar = false
          this.newItem = this.defaultItem
          // this.$router.push({path:`/users/edit/${this.result.id}`, params: {user: this.result}})
        })
        .catch((error) => {
          // console.log(error)
        })
    },
    // close () {
    //   this.dialog = false
    //   setTimeout(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem)
    //     this.editedIndex = -1
    //   }, 300)
    // },
    // save () {
    //   let url = `${this.$globals.apiserver}/support_articles/${this.editedItem.id}.json`
    //   axios.put(url,this.editedItem).then((response) => {
    //     this.result = response.data
    //     this.$store.dispatch('updateArticle', this.result)
    //     // this.snackbar = true
    //   }).catch((error) => { console.log(error) })
    //   // if (this.editedIndex > -1) {
    //   //   Object.assign(this.$store.state.support_articles[this.editedIndex], this.editedItem)
    //   // } else {
    //   //   this.$store.state.support_articles.push(this.editedItem)
    //   // }
    //   this.close()
    // },
    show_create_article_form () {
      this.save_article_form_display = true
    }
    // editItem (item) {
    //   // console.log(item)
    //   this.editedIndex = this.$store.state.support_articles.indexOf(item)
    //   // console.log(this.editedIndex)
    //   this.editedItem = Object.assign({}, item)
    //   // console.log(this.editedItem)
    //   this.dialog = true
    // }
  },
  components: { TextEditor }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/support/Articles.vue